import { UploadOutlined, DeleteFilled } from '@ant-design/icons'
import { Button, Form, Input, Modal, Result, Row, Image, Col, Checkbox } from 'antd'
import { useState, useEffect } from 'react'
import { openMessage } from '../../Utils/MessageDisplay';
import {  apiAssignmentReports } from '../../../../utils/api'
import { prMain } from '../../../../themeConfig'

export const AssignmentReports = ({ data, setIsOpen, close, refresh, setRefresh, setIsAssignment, isVisible, ...props }) => {

    let items = []
    const propertiesToCheck = ['shortCircuit', 'falseContact', 'tablets', 'fuses', 'photocellBase', 'focusWts', 'measurementBase', 'socket', 'photocell'];
    
    const [isOpen, setisOpen] = useState(isVisible)
    const [state, setstate] = useState({})
    const [corto, setCorto] = useState(false)
    const [pastilla, setPastilla] = useState(false)
    const [contacto, setContacto] = useState(false)
    const [fotocelda, setFotocelda] = useState(false)
    const [fusible, setFusible] = useState(false)
    const [foco, setFoco] = useState(false)
    const [base, setBase] = useState(false)
    const [socket, setSocket] = useState(false)
    const [baseFotocelda, setBaseFotocelda] = useState(false)
    const [urls, seturls] = useState({})
    const [images, setImages] = useState([])
    const [reason, setreason] = useState(null)
    const [lighting, setLighting] = useState({
        "shortCircuit": false,
        "falseContact": false,
        "tablets": false,
        "fuses": false,
        "photocellBase": false,
        "focusWts": false,
        "measurementBase": false,
        "socket": false,
        "photocell": false
    })



    const handleClose = () => {
        setisOpen(false)
        setIsAssignment(false)
        setreason('')
    }

    const handleLighting = (e) => {
        switch (e.target.name) {
            case 'corto':
                setCorto(e.target.checked);
                setLighting(prev => ({ ...prev, ["shortCircuit"]: e.target.checked}))
                break;
            case 'pastilla':
                setPastilla(e.target.checked)
                setLighting(prev => ({ ...prev, ["tablets"]: e.target.checked }))
                break;
            case 'contacto':
                setContacto(e.target.checked)
                setLighting(prev => ({ ...prev, ["falseContact"]: e.target.checked }))
                break;
            case 'fotocelda':
                setFotocelda(e.target.checked)
                setLighting(prev => ({ ...prev, ["photocell"]: e.target.checked}))
                break;
            case 'fusible':
                setFusible(e.target.checked)
                setLighting(prev => ({ ...prev, ["fuses"]: e.target.checked }))
                break;
            case 'foco':
                setFoco(e.target.checked)
                setLighting(prev => ({ ...prev, ["focusWts"]: e.target.checked }))
                break;
            case 'base':
                setBase(e.target.checked)
                setLighting(prev => ({ ...prev, ["measurementBase"]: e.target.checked }))
                break;
            case 'socket':
                setSocket(e.target.checked)
                setLighting(prev => ({ ...prev, ["socket"]: e.target.checked }))
                break;
            case 'baseFotocelda':
                setBaseFotocelda(e.target.checked)
                setLighting(prev => ({ ...prev, ["photocellBase"]: e.target.checked }))
                break;
            default:
                break;
        }
    
    }

    const handleConfirmationLight = () => {

        propertiesToCheck.forEach(property => {
            if (lighting[property]) {
                switch (property) {
                    case 'shortCircuit':
                        items += 'Corto circuito';
                        break;
                    case 'falseContact':
                        items += 'Falso contacto';
                        break;
                    case 'tablets':
                        items += 'Pastilla';
                        break;
                    case 'fuses':
                        items += 'Fusibles';
                        break;
                    case 'photocellBase':
                        items += 'Base de fotocelda';
                        break;
                    case 'focusWts':
                        items += 'Foco 65 WTS';
                        break;
                    case 'measurementBase':
                        items += 'Base de medición';
                        break;
                    case 'socket':
                        items += 'Socket E-39';
                        break;
                    case 'photocell':
                        items += 'Fotocelda';
                        break;
                    default:
                        break;
                }
            }
        });
    }

    const handleImage = (e) => {

        if (!e) return
        setstate(prev => ({ ...prev, [e.target.name]: e.target.files[0] }))
        seturls(prev => ({ ...prev, [e.target.name]: URL.createObjectURL(e.target.files[0]) }))

    }
    
    const handleRemoveImage = (name) => {

        if (!name) return

        setstate(prev => ({ ...prev, [name]: null }))
        seturls(prev => ({ ...prev, [name]: null }))
        document.getElementById(name).value = "";
    }

    const handleConfirm = () => {
        handleConfirmationLight()
        apiAssignmentReports(data['id'], images, reason, data['servicesDto']['name'], lighting)
                .then(response => {
                    props.getDataReport()
                    props.handleLogEvent(data.id)
                    openMessage({ type: 'success', message: `Reporte con el folio ${data.id} en revisión` })

                })
                .catch(error => {
                    console.log(error)
                    openMessage({ type: 'error', message: 'Ha ocurrido un error al intentar realizar la petición' })

                })
                handleCloseAll()
    }

    const handleCloseAll = () => {
        setIsAssignment(false)
        close()
    }

    useEffect(() => {
        let obj = {}
        for (let i = 1; i <= 4; i++) {
            obj[`img${i}`] = null
        }
        setstate(obj)
        seturls(obj)
    }, [])

    useEffect(() => {
        setImages(Object.values(state))
    }, [state])

    return (
            <Modal
                centered
                visible={isOpen}
                closable={false}
                footer={null}
                onCancel={() => handleClose()}
            >
                {
                    <>
                        {
                            <Result
                                status={'info'}
                                title='Mover reporte a Revisión'
                                subTitle={`¿Desea mover el reporte con folio ${data.id} a Revisión?`}
                                extra={[
                                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <Row gutter={[20, 24]} style={{ marginLeft: 0, marginBottom: 20 }}>
                                        {
                                            Object.keys(state).map((key) => (
                                                <Col xs={24} sm={24} md={24} lg={12} key={key}>
                                                    <label style={{ backgroundColor: prMain }} className='input-container' >
                                                    <UploadOutlined style={{ marginRight: 10 }} />
                                                    <input
                                                        id={key}
                                                        className='inputSelect'
                                                        type="file"
                                                        accept="image/png, image/jpeg"
                                                        name={key}
                                                        onChange={handleImage}
                                                    />
                                                    Seleccionar Imagen...
                                                    </label>
                                                <div style={{ height: 200, display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 15 }}>
                                                {
                                                    urls[key]
                                                    ? <Image id={key} src={urls[key]} alt={key} height={200} style={{ objectFit: 'cover' }} />
                                                    : <Image
                                                        style={{ objectFit: 'cover' }}
                                                        width={'100%'}
                                                        height={200}
                                                        src="error"
                                                        fallback="data:image/png;base64,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"
                                                    />
                                                }
                                                    <Button icon={<DeleteFilled />} disabled={state[key] === null} type='link' onClick={() => handleRemoveImage(key)}>Remover</Button>
                                                </div>
                                                </Col>
                                            ))
                                        }
                                    </Row>
                                    </div>,
                                    data['servicesDto']['name'] === "Alumbrado" ?
                                    <Row>
                                        <div style={{marginTop: '1rem'}}>
                                            <Checkbox style={{borderRadius: 0}} onChange={(event)=>handleLighting(event)} name={'corto'}>Corto circuito</Checkbox>
                                        </div>
                                        <div style={{marginTop: '1rem'}}>
                                            <Checkbox style={{borderRadius: 0}} onChange={(event)=>handleLighting(event)} name={'pastilla'}>Restablecer pastilla</Checkbox>
                                        </div>
                                        <div style={{marginTop: '1rem'}}>
                                            <Checkbox style={{borderRadius: 0}} onChange={(event)=>handleLighting(event)} name={'contacto'}>Falso contacto</Checkbox>
                                        </div>
                                        <div style={{marginTop: '1rem'}}>
                                            <Checkbox style={{borderRadius: 0}} onChange={(event)=>handleLighting(event)} name={'baseFotocelda'}>Base de fotocelda</Checkbox>
                                        </div>
                                        <div style={{marginTop: '1rem'}}>
                                            <Checkbox style={{borderRadius: 0}} onChange={(event)=>handleLighting(event)} name={'fusible'}>Fusible</Checkbox>
                                        </div>
                                        <div style={{marginTop: '1rem'}}>
                                            <Checkbox style={{borderRadius: 0}} onChange={(event)=>handleLighting(event)} name={'foco'}>Foco 65 WTS</Checkbox>
                                        </div>
                                        <div style={{marginTop: '1rem'}}>
                                            <Checkbox style={{borderRadius: 0}} onChange={(event)=>handleLighting(event)} name={'base'}>Base de medición</Checkbox>
                                        </div>
                                        <div style={{marginTop: '1rem'}}>
                                            <Checkbox style={{borderRadius: 0}} onChange={(event)=>handleLighting(event)} name={'socket'}>Socket E-39</Checkbox>
                                        </div>
                                        <div style={{marginTop: '1rem'}}>
                                            <Checkbox style={{borderRadius: 0}} onChange={(event)=>handleLighting(event)} name={'fotocelda'}>Fotocelda</Checkbox>
                                        </div>
                                    </Row>
                                    : <div></div>,
                                    <Form.Item
                                        key='reason'
                                        help='Ingrese la razón para mover este reporte'
                                        style={{ width: '100%', marginBottom: 15, marginTop: 15 }}
                                    >
                                        <Input name='reason' maxLength={50} value={reason} onChange={e => setreason(e.target.value)} />
                                    </Form.Item>,
                                    <Button disabled={!reason || (images[0] == null && images[1] == null && images[2] == null && images[3] == null) && (!corto && !pastilla&& !contacto&& !baseFotocelda&& !fusible&& !foco&& !base&& !socket&& !fotocelda)} type='link' onClick={handleConfirm} >Completar</Button>,
                                    <Button type='primary' key='cancel' onClick={handleClose}>Cancelar</Button>,
                                ]}
                            />
                        }

                    </>
                }

            </Modal>
    )
}
